export const TOGGLE_FREE_TRIAL = 'TOGGLE_FREE_TRIAL';
export const TOGGLE_TRIAL_EXPIRATION = 'TOGGLE_TRIAL_EXPIRATION';
export const TOGGLE_FREE_BLOCKER = 'TOGGLE_FREE_BLOCKER';
export const TOGGLE_TRIAL_ANNOUNCEMENT = 'TOGGLE_TRIAL_ANNOUNCEMENT';
